/**
 * @readonly
 * @enum {string}
 */
const PAYMENT_INTERVAL = {
  MONTH_1: 'MONTH_1',
  YEAR_1: 'YEAR_1',
};

/**
 * @readonly
 * @enum {string}
 */
const TIER = {
  FREE: 'FREE',
  PRO: 'PRO',
  PREMIUM: 'PREMIUM',
};

export {
  PAYMENT_INTERVAL,
  TIER,
};
